import { useCallback } from "react";
import { cloneDeep } from "lodash";
import { useFormAPI } from "@/widgets/classic-form/form";

export const useToggleFamilyExactness = () => {
    const { setFieldValue, getFieldValue } = useFormAPI();

    return useCallback(
        (newValue: boolean) => {
            const familyValues = getFieldValue("family");
            const valuesCopy = cloneDeep(familyValues);
            Object.values(valuesCopy).forEach((event) => {
                event.instances.forEach((instance) => {
                    instance.givenNameExactness.isExact = newValue;
                    instance.surnameExactness.isExact = newValue;
                });
            });
            setFieldValue("family", valuesCopy);
        },
        [getFieldValue, setFieldValue],
    );
};
